export default __webpack_public_path__ + "static/media/sch6_w640.12910ec1.jpg";